<script>
    import { getContext } from "svelte";
    import { api_info, fetchWithAuthentication } from "../api/client.js";

    const context = getContext(api_info);
    import RequestAdmin from "./forms/RequestAdmin.svelte";
    import TagsAdmin from "./forms/TagsAdmin.svelte";
    import RequestAndTagAdmin from "./forms/RequestAndTagAdmin.svelte";
    import ModelAdmin from "./forms/ModelAdmin.svelte";

    let data_versions = [];
    let data_with_tags_versions = [];
    let model_versions = [];
    let tag_versions = [];

    async function loadData() {
        const response = await fetchWithAuthentication(
            context,
            "/get_all_versions/",
            {}
        );
        data_versions = response.data_versions;
        data_with_tags_versions = response.data_with_tags_versions;
        model_versions = response.model_versions;
        tag_versions = response.tag_versions;
    }
    loadData();
</script>

<RequestAdmin {data_versions} on:file_uploaded={loadData} />

<TagsAdmin {data_versions} {tag_versions} on:new_tag={loadData} />

<RequestAndTagAdmin
    {data_versions}
    {tag_versions}
    {data_with_tags_versions}
    on:new_data_with_tags={loadData}
/>

<ModelAdmin {data_with_tags_versions} {model_versions} />
